module.exports = __webpack_public_path__ + "media/hero.afb6edc8.mp4";